export const handleInputChangeWrapper = (context: any) => (event: any) => {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;
    /* tslint:disable */
    let x: any = {};

    if (context.state.fields && typeof context.state.fields[name] === 'object') {
        x = {
            [name]: {
                ...context.state.fields[name],
                value,
            },
        };
        if (x[name].format) {
            x[name].value = x[name].format(x[name].value);
        }
        context.setState({fields: {...context.state.fields, ...x}});
    } else {
        x = {
            [name]: value,
        };
        context.setState(x);
    }
    /* tslint:enable */
};



// WEBPACK FOOTER //
// ./src/helpers/state.ts